import { Button, Space, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchResultContext } from '../index.context'
import { TableGeneralState } from 'src/app/shared/components/common/table/table.model'
import { useSelector } from 'react-redux'
import { getUserProfile } from 'src/app/store/auth'
import { IGetUserSettingPayload } from 'src/app/shared/models/user.model'
import { FormValues } from '../../all-transactions/index.context'
import { useLocation } from 'react-router-dom'
import { defaultPagination } from 'src/app/shared/components/common/new-table/table.constants'

const QuickFilter: React.FC<{
  props: Partial<TableGeneralState> & {
    loading?: boolean
  }
}> = ({ props }) => {
  const { filterState, filterOptions, outerTableRef, setFilterState, setLoading, handleSearch, getTableName } =
    useSearchResultContext()
  const { t } = useTranslation()
  const userProfile = useSelector(getUserProfile)
  const { state }: { state: FormValues } = useLocation()

  return (
    <Space
      style={{
        marginBottom: 24,
        gap: 16,
      }}
      className='quick-filter-container'
    >
      <Typography
        style={{
          fontWeight: 'bold',
          fontSize: 14,
          wordBreak: 'keep-all',
        }}
      >
        {t('TransactionResult:title.quick_filter')}
      </Typography>
      {filterOptions.map((item) => (
        <Button
          // type='primary'
          style={{
            height: 32,
            borderRadius: 8,
            fontSize: 16,
            lineHeight: '22px',
            padding: '5px 16px',
          }}
          className={`quick-filter ${filterState.selectedFilter === item.value ? 'filter-selected' : ''} ${
            filterState.disabledFilter.includes(item.value) ? 'filter-disabled' : ''
          }`}
          disabled={filterState.disabledFilter.includes(item.value) || props.loading}
          onClick={async () => {
            const type = item.value === filterState.selectedFilter ? state.transactionType : item.value
            setFilterState((prev) => ({
              ...prev,
              selectedFilter: type,
            }))
            if (userProfile.userId) {
              setLoading(true)
              try {
                const payload: IGetUserSettingPayload = {
                  userId: userProfile.userId,
                  tableName: getTableName(type),
                }
                const res = await outerTableRef.current?.getSetting?.(payload)
                const sort = outerTableRef.current?.getSortColumns?.(res ?? [])
                await handleSearch({
                  ...props,
                  transactionType: type,
                  sortColumnsDictionary: sort,
                  pageIndex: defaultPagination,
                })
                outerTableRef.current?.setSortColumnDictionary?.(sort)
                outerTableRef.current?.setCurrentPage?.(defaultPagination)
              } catch (error) {
                setLoading(false)
              }
            }
          }}
        >
          {item.label}
        </Button>
      ))}
    </Space>
  )
}

export default QuickFilter
